import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { BackupConfigurationsDialogData } from '@app/shared/components/dialogs/backup-configurations-dialog/backup-configurations-dialog.data';

@Component({
    selector : 'backup-configurations',
    template: require('./backup-configurations-dialog-component.html'),
    styles: [require('./backup-configurations-dialog-component.scss')]
})
export class BackupConfigurationsDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: BackupConfigurationsDialogData) {
        
    }

    envsForEnvType(envTypeId) {
                        if (this.data.envTypeNames.length !== 0 && envTypeId) {
                            const result = this.data.envNames.filter(env => {
                                return env.envTypeId == envTypeId;
                            })
                            this.data.envsForEnvTypeChosen = result;
            }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/backup-configurations-dialog/backup-configurations-dialog-component.ts